import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/Sale/OrderClient/SaleOrderClientList/components/List';
import Search from '#app/View/Sale/OrderClient/SaleOrderClientList/components/Search';
import useOrderClientList from '#app/View/Sale/OrderClient/SaleOrderClientList/hooks/useOrderClientList';

const SaleOrderClientList: React.FC = () => {
  const { setFilters, filters, ...props } = useOrderClientList();

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des commandes client', context: 'Vente' }}>
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <List {...props} />
    </ContentViewComponent>
  );
};

export default SaleOrderClientList;
